(function (ws) {
    ws.views.atcNotification = ws.views.notification.extend({
        initialize() {
            ws.views.notification.prototype.initialize.call(this);

            this.$partNo = this.$('[data-part-no]');
            this.$partQty = this.$('[data-part-qty]');
            this.$partPrice = this.$('[data-part-price]');
            this.$cartItems = this.$('[data-cart-items]');
            this.$cartQty = this.$('[data-cart-qty]');
            this.$cartValue = this.$('[data-cart-value]');

            this.listenTo(this.eventAgg, 'showAddedNotification', this.respondToAdded);
            this.listenTo(this.eventAgg, 'minicartOpened', this.respondToMinicart);
        },

        respondToAdded(response) {
            const data = response.data[0];

            this.$partNo.text(data.partsNo);
            this.$partQty.text(data.quantity);
            this.$partPrice.text(data.latestEntryTotal.formattedValue);
            this.$cartItems.text(data.miniCartData.totalItems);
            this.$cartQty.text(data.miniCartData.totalQty);
            this.$cartValue.text(data.miniCartData.subTotal);

            this.showNotification();
        },

        respondToMinicart() {
            this.hideNotification();
        }
    });

})(westcon);
